import type { ReactNode } from "react";
import { useSessao } from "./useSessao";
import { Entrar } from "@/telas/Entrar";

/*
 * A porta do painel.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ ISTO NÃO É UM CONTROLE DE ACESSO.                                        │
 * │                                                                          │
 * │ Quem autoriza é a API, que recusa toda requisição sem token válido e     │
 * │ registra a tentativa na auditoria. Este componente decide o que APARECE  │
 * │ na tela — nada mais. Um painel que dependesse dele para proteger dado    │
 * │ estaria protegido por um `if` que roda na máquina de quem quer entrar.   │
 * └──────────────────────────────────────────────────────────────────────────┘
 */
export function RotaProtegida({ children }: { children: ReactNode }) {
  const { estado } = useSessao();

  if (estado.fase === "verificando") {
    /*
     * Enquanto o servidor responde se o cookie de refresh ainda vale.
     *
     * Mostrar a tela de acesso aqui seria pior que esperar: quem recarrega a
     * página com sessão viva veria um formulário de login piscar e sumir, e
     * gente digita e-mail em formulário que pisca.
     */
    return (
      <div
        role="status"
        aria-label="Verificando a sessão"
        className="flex min-h-dvh items-center justify-center bg-breu text-texto-3"
      >
        <span className="rotulo">verificando a sessão</span>
      </div>
    );
  }

  if (estado.fase === "fora") return <Entrar />;

  return <>{children}</>;
}
